import itemHasPermission from './itemHasPermission';
import itemHasOrganisation from './itemHasOrganisation';
import resolveRoute from './resolveRoute';
import uuid from '@/lib/helpers/uuid';

const getMenu = async (menu, level = 0) => {
    try {
        if (typeof menu === 'string') {
            menu = (await import(`@/router/menus/${menu}.js`)).default;
        }
    } catch (error) {
        console.error('Cannot find menu:', `@/router/menus/${menu}.js`, error);
        menu = [];
    }

    // Remove the unauthorised items
    let items = menu.filter(item => {
        if (!itemHasPermission(item)) {
            return false;
        }

        if (!itemHasOrganisation(item)) {
            return false;
        }

        return true;
    });

    for (const itemIndex in items) {
        let item = items[`${itemIndex}`];

        if ('children' in item && item.children.length) {
            item.hasChildren = true;
            item.children = await getMenu(item.children, level + 1);
        }

        if ('getChildren' in item) {
            item.hasChildren = true;
        }

        item.active = false;

        if (!item.href && !('path' in item)) {
            const route = await resolveRoute(item.route);
            if (route) {
                item.path = route.route.path
                    .split('/')
                    .filter(part => {
                        return !part.includes('?');
                    })
                    .join('/');
            }
        }

        if (!('id' in item)) {
            item.id = uuid();
        }

        item.level = level;

        items[`${itemIndex}`] = item;
    }

    items = items.filter(item => {
        if (item.hasChildren && !item.children.length) {
            return false;
        }

        return true;
    });

    return items;
};

export default getMenu;
